interface StripeConfig {
  dashboardUrl: string;
  isTest: boolean;
}

function composeStripeURL(
  stripeConfig: StripeConfig,
  platformId: string | undefined,
  path: string,
): string {
  let base = stripeConfig.dashboardUrl;
  if (platformId !== undefined) {
    base = base + "/" + platformId;
  }

  return base + path;
}

export function getTransferURL(
  stripeConfig: StripeConfig,
  platformId: string | undefined,
  transferId: string,
): string {
  let path = "/connect/transfers/" + transferId;
  if (stripeConfig.isTest === true) {
    path = "/test" + path;
  }
  return composeStripeURL(stripeConfig, platformId, path);
}

export function getPaymentURL(
  stripeConfig: StripeConfig,
  platformId: string | undefined,
  paymentId: string,
): string {
  let path = "/payments/" + paymentId;
  if (stripeConfig.isTest === true) {
    path = "/test" + path;
  }
  return composeStripeURL(stripeConfig, platformId, path);
}

export function getPayoutURL(
  stripeConfig: StripeConfig,
  platformId: string | undefined,
  accountId: string,
  payoutId: string,
): string {
  let path = "/payouts/" + payoutId;
  if (stripeConfig.isTest === true) {
    path = "/test" + path;
  }
  path = "/connect/view-as/" + accountId + path;

  return composeStripeURL(stripeConfig, platformId, path);
}

export function getCustomerURL(
  stripeConfig: StripeConfig,
  platformId: string | undefined,
  customerId: string,
): string {
  let path = "/customers/" + customerId;

  if (stripeConfig.isTest === true) {
    path = "/test" + path;
  }
  return composeStripeURL(stripeConfig, platformId, path);
}

export function getAccountURL(
  stripeConfig: StripeConfig,
  platformId: string | undefined,
  accountId: string,
): string {
  let path = "/connect/accounts/" + accountId;

  if (stripeConfig.isTest === true) {
    path = "/test" + path;
  }
  return composeStripeURL(stripeConfig, platformId, path);
}
